import React, { useRef, useState } from 'react';
import { upload } from '../services/api';
import toast from 'react-hot-toast';

export default function ImageUpload({ C, value, onChange, max=5, label='Upload Images' }) {
  const [uploading, setUploading] = useState(false);
  const inputRef = useRef();
  const images = value || [];

  const handleFiles = async (files) => {
    if (images.length + files.length > max) {
      toast.error(`Max ${max} images allowed`);
      return;
    }
    setUploading(true);
    const uploaded = [];
    for (const file of files) {
      if (file.size > 10 * 1024 * 1024) {
        toast.error(`${file.name} too large (max 10MB)`);
        continue;
      }
      try {
        const res = await upload(file);
        uploaded.push(res.url);
      } catch(e) {
        toast.error(`${file.name}: ${e.message}`);
      }
    }
    onChange([...images, ...uploaded]);
    setUploading(false);
    if (inputRef.current) inputRef.current.value = '';
  };

  const remove = (idx) => {
    onChange(images.filter((_, i) => i !== idx));
  };

  return (
    <div style={{marginBottom:10}}>
      <div style={{fontSize:11,color:C.muted,marginBottom:6,fontWeight:600}}>{label} ({images.length}/{max})</div>
      <div style={{display:'flex',gap:6,flexWrap:'wrap',marginBottom:8}}>
        {images.map((url, i) => (
          <div key={i} style={{position:'relative',width:64,height:64,borderRadius:8,overflow:'hidden',border:`1px solid ${C.border}`}}>
            <img src={url} alt="" style={{width:'100%',height:'100%',objectFit:'cover'}} />
            <button onClick={()=>remove(i)} style={{position:'absolute',top:2,right:2,background:'rgba(239,68,68,0.9)',color:'#fff',border:'none',borderRadius:'50%',width:18,height:18,fontSize:10,cursor:'pointer',padding:0,lineHeight:1}}>×</button>
          </div>
        ))}
        {images.length < max && (
          <button onClick={()=>inputRef.current?.click()} disabled={uploading} style={{
            width:64,height:64,background:C.input,border:`1px dashed ${C.border}`,borderRadius:8,
            cursor:uploading?'wait':'pointer',color:C.muted,fontSize:24
          }}>{uploading ? '...' : '+'}</button>
        )}
      </div>
      <input ref={inputRef} type="file" accept="image/*" multiple onChange={e=>handleFiles(Array.from(e.target.files))} style={{display:'none'}} />
    </div>
  );
}
